module.exports = __webpack_public_path__ + "static/media/siddharth-naidu-cv.c15d9333.pdf";